import React from 'react'

const FileEditIcon = () => {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 22.0002V18.0002H20V22.0002H0ZM2 16.0002V12.2502L11.05 3.20018L14.8 6.95018L5.75 16.0002H2ZM4 14.0002H4.9L12 6.95018L11.05 6.00018L4 13.1002V14.0002ZM15.925 5.85018L12.175 2.10018L13.975 0.30018C14.1583 0.10018 14.3917 0.00418029 14.675 0.0121803C14.9583 0.020847 15.1917 0.116847 15.375 0.30018L17.725 2.65018C17.9083 2.83351 18 3.06285 18 3.33818C18 3.61285 17.9083 3.85018 17.725 4.05018L15.925 5.85018Z"
        fill="#A4A5A7"
      />
    </svg>
  )
}

export default FileEditIcon
